// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InternalPriceList.yaml
// Generated: 2026-07-10T16:19:38.455Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateInternalPriceList, UpdateInternalPriceList, InternalPriceList } from '@/types/pricing/InternalPriceList';

/**
 * InternalPriceList Service
 * CRUD operations for InternalPriceList via the ABP API.
 */
export const internalPriceListService = new EntityService<InternalPriceList, CreateInternalPriceList, UpdateInternalPriceList>(
  '/api/pricing/internalpricelist',
  'InternalPriceList',
);
